export const SET_JOB_HISTORY = "SET_JOB_HISTORY";
export const SET_LOADING_JOB_HISTORY = "SET_LOADING_JOB_HISTORY";
export const SET_ERROR_PROMPT_JOB_HISTORY_PAGE = "SET_ERROR_PROMPT_JOB_HISTORY_PAGE";
export const SET_ERROR_MESSAGE_JOB_HISTORY_PAGE = "SET_ERROR_MESSAGE_JOB_HISTORY_PAGE";
export const SET_JOB_HISTORY_PAGE = "SET_JOB_HISTORY_PAGE";
